import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, Diamond, ArrowRight, Sparkles, Globe, Flower2 } from "lucide-react";
import { WEDDING_CITIES } from "@/weddingsConfig";
import Logo from "@/components/Logo";
import WeddingsFooterFull from "@/components/WeddingsFooterFull";
import { getLangFromWindow, setLangInWindowUrl } from "@/utils/seoLang";
import axios from "axios";
import FaqSection from "@/components/weddings/FaqSection";
import WeddingMobileMenu from "@/components/weddings/WeddingMobileMenu";
import HubLeadForm from "@/components/HubLeadForm";

const WA_PHONE = "905316224378";
const WA_LINK = `https://wa.me/${WA_PHONE}`;

function getLang() {
  return getLangFromWindow(["ru", "en"]);
}

const COPY = {
  ru: {
    title: "Свадебная флористика — премиум-оформление свадеб в Турции, Испании, Греции, ОАЭ | YUCCA",
    description: "Свадебная флористика премиум-класса в Бодруме, на Ибице, на Санторини, в Дубае, Стамбуле, Барселоне. Полное оформление от букета невесты до банкета. От €2500. Запросите смету за 24 часа.",
    keywords: "свадебная флористика, оформление свадеб, цветы на свадьбу, букет невесты, свадебный флорист, wedding florist, destination wedding flowers",
    eyebrow: "СВАДЕБНАЯ ФЛОРИСТИКА",
    heroTitle: "Свадьбы, в которых",
    heroTitleAccent: "каждый цветок — со смыслом",
    heroSubtitle: "Премиум-флористика для destination-свадеб. Полное оформление под ключ — от букета невесты до банкета. Работаем в Турции, Испании, ОАЭ и других странах.",
    ctaPrimary: "ЗАПРОСИТЬ СМЕТУ",
    ctaSecondary: "ВЫБРАТЬ ГОРОД",
    citiesEyebrow: "ГДЕ МЫ РАБОТАЕМ",
    citiesTitle: "Выберите город вашей",
    citiesTitleAccent: "свадьбы",
    citiesSubtitle: "Каждый город — свой стиль, свои локации, свои сезоны. Откройте страницу города, чтобы увидеть пакеты, площадки и детали.",
    soonLabel: "СКОРО",
    soonCities: [
      { name: "Анталья", country: "Турция" },
      { name: "Стамбул", country: "Турция" },
      { name: "Алания", country: "Турция" },
      { name: "Дубай", country: "ОАЭ" },
      { name: "Барселона", country: "Испания" },
      { name: "Монако", country: "Монако" },
    ],
    valueEyebrow: "ПОЧЕМУ YUCCA",
    valueTitle: "Свадебная флористика,",
    valueTitleAccent: "которой можно доверять",
    valueSubtitle: "Мы работаем с премиум-отелями и виллами, говорим на русском и английском, и относимся к каждой свадьбе как к единственной.",
    values: [
      { title: "Свежие цветы каждый день", text: "Поставки из Эквадора, Кении, Голландии. Premium-сорта в любой сезон." },
      { title: "Индивидуальный концепт", text: "Без шаблонов. Палитра, форма, акценты — всё под ваше платье и площадку." },
      { title: "Премиум-площадки", text: "Знаем требования топовых отелей и вилл — от Mandarin до Six Senses." },
      { title: "Полное сопровождение", text: "От первого звонка до демонтажа после церемонии. На русском и английском." },
    ],
    hookQuote: "Каждая невеста — единственная.",
    hookQuoteAccent: "Каждая свадьба — своя история.",
    hookSubtitle: "10 лет работы в Турции, Испании, Италии, Греции, ОАЭ, Таиланде и Монако. Десятки направлений, сотни деталей, единый стандарт качества. Куда бы вы ни поехали — мы создадим свадьбу, о которой будут говорить годами.",
    hookStats: [
      { value: "7", label: "стран присутствия" },
      { value: "10+", label: "destination-городов" },
      { value: "80+", label: "оформленных свадеб" },
      { value: "5.0", label: "средний рейтинг" },
    ],
    partnersEyebrow: "НАМ ДОВЕРЯЮТ",
    partnersTitle: "Премиум-отели, виллы и event-агентства мира",
    partners: [
      "MANDARIN ORIENTAL", "CARESSE", "THE BODRUM EDITION", "MAXX ROYAL",
      "SIX SENSES KAPLANKAYA", "KEMPINSKI", "FOUR SEASONS", "ATLANTIS THE PALM",
      "BURJ AL ARAB", "ME IBIZA", "HOTEL DE PARIS MONACO", "AMAN VENICE",
    ],
    bottomTitle: "Расскажите о вашей",
    bottomTitleAccent: "свадьбе",
    bottomSubtitle: "Бесплатная консультация и персональный мудборд в течение 24 часов. Куда бы вы ни планировали свадьбу — мы будем рядом.",
    contactCta: "СВЯЗАТЬСЯ С НАМИ",
    seoEyebrow: "DESTINATION WEDDING С YUCCA",
    seoTitle: "Свадебная флористика в",
    seoTitleAccent: "Турции, Испании, Италии, Греции, ОАЭ и Монако",
    seoBlocks: [
      {
        heading: "Что такое destination wedding",
        content: "Destination wedding — это свадьба за границей, организованная в стране, отличной от страны проживания пары. По данным мировых wedding-площадок, в 2025 году каждая четвёртая пара из Европы и СНГ выбирает destination-формат. Преимущества очевидны: уникальные локации у моря или в горах, премиум-сервис, объединение свадьбы и медового месяца, фотографии, которые невозможно сделать дома. Турция, Испания, ОАЭ и Монако возглавляют топ направлений по соотношению цена-качество, инфраструктуре и логистике.",
      },
      {
        heading: "Почему YUCCA — лучший флорист для destination-свадьбы",
        content: "Мы работаем на нескольких рынках одновременно: Бодрум, Анталья, Стамбул (Турция), Барселона, Аликанте, Ибица (Испания), Санторини, Миконос (Греция), озеро Комо (Италия), Дубай (ОАЭ), Пхукет (Таиланд), Монако. Это значит — единый стандарт сервиса, премиум-цветы из Эквадора, Кении и Голландии, прямые контракты с топовыми отелями (Mandarin Oriental, Caresse, Six Senses, Canaves Oia, Villa del Balbianello, Four Seasons, Burj Al Arab), команды флористов на месте в каждой стране. Мы говорим на русском, английском и турецком, ведём свадьбу удалённо по Zoom и прибываем за день до церемонии для финальной установки.",
      },
      {
        heading: "Сколько стоит свадебная флористика за рубежом",
        content: "Бюджет свадебного оформления зависит от страны, локации, количества гостей и сезона. В Турции и Испании стартовые пакеты — от €2 500 (камерная свадьба до 30 гостей), Signature — от €5 000 (до 50 гостей), Bespoke — от €9 000 (100+ гостей с премиальными сортами). В ОАЭ и Монако бюджеты выше на 30-50% за счёт логистики цветов и стоимости работы команды. В Таиланде и Балканах — на 15-20% ниже. Мы всегда присылаем персональную смету в течение 24 часов после первого запроса, без скрытых платежей и наценок.",
      },
      {
        heading: "Сезонность и лучшее время для свадьбы",
        content: "Турция и Испания — пик сезона май-сентябрь, идеальная погода октябрь-апрель для тех, кто хочет избежать жары. ОАЭ — октябрь-март, в летние месяцы свадьбы перемещаются в indoor-локации с кондиционированием. Монако — май-сентябрь с праздником цветов в конце мая. Таиланд — ноябрь-март (сухой сезон). Мы рекомендуем бронировать дату минимум за 4-6 месяцев в peak-сезон и за 2-3 месяца в shoulder-сезон, чтобы зарезервировать редкие сорта цветов и лучших фотографов.",
      },
    ],
    seoFinal: "YUCCA — это команда флористов и event-дизайнеров с 10-летним опытом destination-свадеб. Куда бы вы ни поехали — в крошечную церковь Монако, на пирс Caresse Bodrum, в инфинити-бассейн Burj Al Arab или на пляж Ибицы — мы создадим свадьбу, которая будет вашей единственной историей. Напишите нам в WhatsApp или оставьте заявку — пришлём мудборд и смету в течение 24 часов.",
    seoCta: "Запросить мудборд и смету",
    lead: {
      eyebrow: "ЗАЯВКА НА СВАДЬБУ",
      title: "Расскажите о вашей",
      titleAccent: "свадьбе мечты",
      subtitle: "Оставьте заявку — пришлём мудборд и смету в течение 24 часов. Или напишите нам напрямую в WhatsApp.",
      nameLabel: "Имя", namePh: "Ваше имя",
      contactLabel: "Контакт", contactPh: "WhatsApp, телефон или e-mail",
      dateLabel: "Дата свадьбы", datePh: "Примерная дата",
      cityLabel: "Направление", messageLabel: "Детали",
      messagePh: "Локация, количество гостей, стиль и пожелания по цветам",
      submit: "ОТПРАВИТЬ ЗАЯВКУ", sending: "ОТПРАВЛЯЕМ…", orWhatsApp: "НАПИСАТЬ В WHATSAPP",
      required: "Укажите имя и контакт для связи.",
      errorMsg: "Не удалось отправить. Попробуйте ещё раз или напишите в WhatsApp.",
      successTitle: "Заявка отправлена!",
      successMsg: "Мы свяжемся с вами в течение 24 часов с мудбордом и сметой.",
    },
  },
  en: {
    title: "Wedding Floristry — Premium Wedding Design in Turkey, Spain, Greece, UAE | YUCCA",
    description: "Premium wedding floristry in Bodrum, Ibiza, Santorini, Dubai, Istanbul, Barcelona. Full design from bridal bouquet to banquet. From €2,500. Get a quote within 24 hours.",
    keywords: "wedding florist, wedding flowers, bridal bouquet, destination wedding flowers, luxury wedding florist, wedding floral design",
    eyebrow: "WEDDING FLORISTRY",
    heroTitle: "Weddings where every",
    heroTitleAccent: "flower has meaning",
    heroSubtitle: "Premium floristry for destination weddings. Full turnkey design — from the bridal bouquet to banquet styling. We work in Turkey, Spain, UAE and beyond.",
    ctaPrimary: "GET A QUOTE",
    ctaSecondary: "CHOOSE A CITY",
    citiesEyebrow: "WHERE WE WORK",
    citiesTitle: "Choose the city of your",
    citiesTitleAccent: "wedding",
    citiesSubtitle: "Every city has its own style, venues and seasons. Open the city page to see packages, locations and details.",
    soonLabel: "COMING SOON",
    soonCities: [
      { name: "Antalya", country: "Turkey" },
      { name: "Istanbul", country: "Turkey" },
      { name: "Alanya", country: "Turkey" },
      { name: "Dubai", country: "UAE" },
      { name: "Barcelona", country: "Spain" },
      { name: "Monaco", country: "Monaco" },
    ],
    valueEyebrow: "WHY YUCCA",
    valueTitle: "Wedding floristry",
    valueTitleAccent: "you can trust",
    valueSubtitle: "We work with premium hotels and villas, speak Russian and English, and treat every wedding as a one-of-a-kind event.",
    values: [
      { title: "Fresh flowers daily", text: "Sourced from Ecuador, Kenya, Netherlands. Premium varieties in every season." },
      { title: "Bespoke concept", text: "No templates. Palette, form, accents — all tailored to your dress and venue." },
      { title: "Premium venues", text: "We know the requirements of top hotels and villas — from Mandarin to Six Senses." },
      { title: "Full support", text: "From the first call to post-ceremony breakdown. In Russian and English." },
    ],
    hookQuote: "Every bride is one of a kind.",
    hookQuoteAccent: "Every wedding tells its own story.",
    hookSubtitle: "10 years of work across Turkey, Spain, Italy, Greece, UAE, Thailand and Monaco. Multiple destinations, hundreds of details, one standard of excellence. Wherever you choose to celebrate — we will create a wedding people talk about for years.",
    hookStats: [
      { value: "7", label: "countries served" },
      { value: "10+", label: "destination cities" },
      { value: "80+", label: "weddings designed" },
      { value: "5.0", label: "average rating" },
    ],
    partnersEyebrow: "TRUSTED BY",
    partnersTitle: "Premium hotels, villas and event agencies worldwide",
    partners: [
      "MANDARIN ORIENTAL", "CARESSE", "THE BODRUM EDITION", "MAXX ROYAL",
      "SIX SENSES KAPLANKAYA", "KEMPINSKI", "FOUR SEASONS", "ATLANTIS THE PALM",
      "BURJ AL ARAB", "ME IBIZA", "HOTEL DE PARIS MONACO", "AMAN VENICE",
    ],
    bottomTitle: "Tell us about your",
    bottomTitleAccent: "wedding",
    bottomSubtitle: "Free consultation and a personalised moodboard within 24 hours. Wherever you plan your wedding — we are there for you.",
    contactCta: "CONTACT US",
    seoEyebrow: "DESTINATION WEDDINGS WITH YUCCA",
    seoTitle: "Wedding floristry in",
    seoTitleAccent: "Turkey, Spain, Italy, Greece, UAE and Monaco",
    seoBlocks: [
      {
        heading: "What is a destination wedding",
        content: "A destination wedding is a wedding held in a country other than where the couple lives. According to global wedding platforms, in 2025 one in four couples from Europe and the CIS choose the destination format. The advantages are obvious: unique seaside or mountain venues, premium service, combining a wedding with a honeymoon, and photographs that simply cannot be replicated at home. Turkey, Spain, the UAE and Monaco lead the rankings in value-for-money, infrastructure and logistics.",
      },
      {
        heading: "Why YUCCA is the right florist for a destination wedding",
        content: "We operate in multiple markets simultaneously: Bodrum, Antalya, Istanbul (Turkey), Barcelona, Alicante, Ibiza (Spain), Santorini, Mykonos (Greece), Lake Como (Italy), Dubai (UAE), Phuket (Thailand) and Monaco. That means a single standard of service, premium flowers from Ecuador, Kenya and the Netherlands, direct contracts with leading hotels (Mandarin Oriental, Caresse, Six Senses, Canaves Oia, Villa del Balbianello, Four Seasons, Burj Al Arab), and floristry teams on the ground in every country. We work in English, Russian and Turkish, run weddings remotely over Zoom and arrive on site one day before the ceremony for the final setup.",
      },
      {
        heading: "How much does wedding floral design abroad cost",
        content: "The budget depends on country, venue, guest count and season. In Turkey and Spain starter packages begin at €2,500 (intimate weddings up to 30 guests), Signature from €5,000 (up to 50), Bespoke from €9,000 (100+ guests with premium varieties). In the UAE and Monaco budgets are 30-50% higher due to flower logistics and team costs. In Thailand and the Balkans they are 15-20% lower. We always send a personalised quote within 24 hours of the first enquiry — no hidden fees or surprises.",
      },
      {
        heading: "Seasonality and the best time for a wedding",
        content: "Turkey and Spain — peak season May to September, ideal mild weather October to April for those who want to avoid the heat. UAE — October to March; in summer weddings move indoors to air-conditioned venues. Monaco — May to September, with the flower festival in late May. Thailand — November to March (dry season). We recommend booking your date at least 4-6 months ahead in peak season and 2-3 months in shoulder season to reserve rare floral varieties and the best photographers.",
      },
    ],
    seoFinal: "YUCCA is a team of florists and event designers with 10 years of destination wedding experience. Wherever you go — a tiny chapel in Monaco, the Caresse Bodrum pier, the Burj Al Arab infinity pool, or a beach in Ibiza — we will create a wedding that will be your only story. Message us on WhatsApp or send an enquiry — we will respond with a moodboard and quote within 24 hours.",
    seoCta: "Get a moodboard and quote",
    lead: {
      eyebrow: "WEDDING ENQUIRY",
      title: "Tell us about your",
      titleAccent: "dream wedding",
      subtitle: "Leave a request — we'll reply with a moodboard and quote within 24 hours. Or message us directly on WhatsApp.",
      nameLabel: "Name", namePh: "Your name",
      contactLabel: "Contact", contactPh: "WhatsApp, phone or e-mail",
      dateLabel: "Wedding date", datePh: "Approximate date",
      cityLabel: "Destination", messageLabel: "Details",
      messagePh: "Venue, guest count, style and flower preferences",
      submit: "SEND ENQUIRY", sending: "SENDING…", orWhatsApp: "MESSAGE ON WHATSAPP",
      required: "Please provide your name and contact.",
      errorMsg: "Couldn't send. Please try again or message us on WhatsApp.",
      successTitle: "Enquiry sent!",
      successMsg: "We'll be in touch within 24 hours with a moodboard and quote.",
    },
  },
};

function SeoTags({ lang, t }) {
  useEffect(() => {
    document.title = t.title;
    const set = (n, c) => {
      let el = document.querySelector(`meta[name="${n}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("name", n); document.head.appendChild(el); }
      el.setAttribute("content", c);
    };
    set("description", t.description);
    set("keywords", t.keywords);
    const origin = window.location.origin;
    const link = (rel, href, hreflang) => {
      const sel = `link[rel="${rel}"]${hreflang ? `[hreflang="${hreflang}"]` : ""}`;
      let el = document.querySelector(sel);
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); if (hreflang) el.setAttribute("hreflang", hreflang); document.head.appendChild(el); }
      el.setAttribute("href", href);
    };
    link("canonical", `${origin}/weddings${lang !== "ru" ? `?lang=${lang}` : ""}`);
    link("alternate", `${origin}/weddings`, "ru");
    link("alternate", `${origin}/weddings?lang=en`, "en");
  }, [lang, t]);

  const origin = typeof window !== "undefined" ? window.location.origin : "https://yuccaflower.com";
  const activeCities = Object.values(WEDDING_CITIES);

  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Service",
        name: t.title,
        description: t.description,
        serviceType: lang === "en" ? "Wedding floristry" : "Свадебная флористика",
        provider: { "@type": "LocalBusiness", name: "YUCCA Flowers", url: "https://yuccaflower.com" },
        areaServed: [
          { "@type": "Country", name: lang === "en" ? "Turkey" : "Турция" },
          { "@type": "Country", name: lang === "en" ? "Spain" : "Испания" },
          { "@type": "Country", name: lang === "en" ? "Greece" : "Греция" },
          { "@type": "Country", name: lang === "en" ? "Italy" : "Италия" },
          { "@type": "Country", name: lang === "en" ? "United Arab Emirates" : "ОАЭ" },
          { "@type": "Country", name: lang === "en" ? "Thailand" : "Таиланд" },
          { "@type": "Country", name: "Monaco" },
        ],
        offers: { "@type": "AggregateOffer", priceCurrency: "EUR", lowPrice: "2500", highPrice: "15000" },
      },
      {
        "@type": "LocalBusiness",
        "@id": `${origin}/#business`,
        name: "YUCCA Flowers",
        url: "https://yuccaflower.com",
        telephone: "+905316224378",
        image: `${origin}/og-image.jpg`,
        priceRange: "€€€",
        areaServed: [
          { "@type": "Country", name: lang === "en" ? "Turkey" : "Турция" },
          { "@type": "Country", name: lang === "en" ? "Spain" : "Испания" },
          { "@type": "Country", name: lang === "en" ? "Greece" : "Греция" },
          { "@type": "Country", name: lang === "en" ? "Italy" : "Италия" },
          { "@type": "Country", name: lang === "en" ? "United Arab Emirates" : "ОАЭ" },
          { "@type": "Country", name: lang === "en" ? "Thailand" : "Таиланд" },
          { "@type": "Country", name: "Monaco" },
        ],
        aggregateRating: { "@type": "AggregateRating", ratingValue: "5.0", reviewCount: "80", bestRating: "5", worstRating: "1" },
      },
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: lang === "en" ? "Home" : "Главная", item: `${origin}/${lang !== "ru" ? `?lang=${lang}` : ""}` },
          { "@type": "ListItem", position: 2, name: lang === "en" ? "Weddings" : "Свадьбы", item: `${origin}/weddings${lang !== "ru" ? `?lang=${lang}` : ""}` },
        ],
      },
      {
        "@type": "ItemList",
        name: lang === "en" ? "Wedding destinations by YUCCA Flowers" : "Свадебные направления YUCCA Flowers",
        numberOfItems: activeCities.length + t.soonCities.length,
        itemListElement: [
          ...activeCities.map((c, i) => ({
            "@type": "ListItem",
            position: i + 1,
            url: `${origin}/weddings/${c.slug}${lang !== "ru" ? `?lang=${lang}` : ""}`,
            name: `${lang === "en" ? "Wedding floristry in" : "Свадебная флористика —"} ${lang === "en" ? c.nameEn : c.name}`,
          })),
          ...t.soonCities.map((c, i) => ({
            "@type": "ListItem",
            position: activeCities.length + i + 1,
            name: `${c.name} (${t.soonLabel})`,
          })),
        ],
      },
    ],
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />;
}

export default function WeddingsHubPage() {
  const [lang, setLang] = useState(getLang());
  const t = COPY[lang];

  const [weddingFaq, setWeddingFaq] = useState([]);
  useEffect(() => {
    let active = true;
    axios
      .get("/api/faq", { params: { kind: "wedding-hub", lang } })
      .then((r) => { if (active) setWeddingFaq(r.data.items || []); })
      .catch(() => { if (active) setWeddingFaq([]); });
    return () => { active = false; };
  }, [lang]);
  const faqTitle = lang === "en" ? "Wedding floristry — FAQ" : "Свадебная флористика — частые вопросы";

  // Sync URL if lang was auto-detected from browser/localStorage
  useEffect(() => {
    if (typeof window === "undefined") return;
    const urlLang = new URLSearchParams(window.location.search).get("lang");
    if (urlLang === lang) return;
    if (lang === "ru" && !urlLang) return;
    setLangInWindowUrl(lang);
  }, [lang]);

  const switchLang = () => {
    const next = lang === "ru" ? "en" : "ru";
    setLang(next);
    setLangInWindowUrl(next);
  };

  const activeCities = Object.values(WEDDING_CITIES);

  return (
    <div className="bg-white" data-testid="weddings-hub-page">
      <SeoTags lang={lang} t={t} />

      {/* Top nav */}
      <nav className="absolute top-0 left-0 right-0 z-30">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-10 py-4 sm:py-5 flex items-center justify-between">
          <div className="text-white"><Logo variant="gold" /></div>
          <div className="hidden lg:flex items-center gap-8 text-[12px] tracking-[0.2em] text-white/85 font-light">
            <Link to={`/${lang !== "ru" ? `?lang=${lang}` : ""}`} className="hover:text-white">{lang === "en" ? "SHOP" : "МАГАЗИН"}</Link>
            <span className="text-white font-medium border-b border-[#C9A87C] pb-1">{lang === "en" ? "WEDDINGS" : "СВАДЬБЫ"}</span>
            <Link to={`/blog${lang !== "ru" ? `?lang=${lang}` : ""}`} className="hover:text-white">{lang === "en" ? "BLOG" : "БЛОГ"}</Link>
          </div>
          <div className="flex items-center gap-2 sm:gap-3">
            <button onClick={switchLang} className="text-[11px] sm:text-[12px] tracking-[0.2em] text-white/85 hover:text-white px-2" data-testid="hub-lang-switch">
              {lang === "en" ? "EN" : "RU"}
            </button>
            <a href={WA_LINK} target="_blank" rel="noopener noreferrer"
               className="hidden md:inline-flex items-center px-6 py-3 bg-white text-[#1F1815] text-[11px] tracking-[0.25em] font-medium hover:bg-[#F5EDE0] transition rounded-sm">
              {t.ctaPrimary}
            </a>
            <WeddingMobileMenu lang={lang} />
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="relative h-[560px] sm:h-[680px] lg:h-[720px] overflow-hidden" data-testid="hub-hero">
        <div className="absolute inset-0">
          <img src="/weddings/bodrum/hero.webp" alt={t.title} className="absolute inset-0 w-full h-full object-cover object-right sm:object-center" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0A0807]/95 via-[#0A0807]/75 to-[#0A0807]/30" />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#0A0807]" />
        </div>
        <div className="relative z-10 max-w-[1400px] mx-auto px-6 sm:px-10 h-full flex flex-col justify-center">
          <p className="text-[10px] sm:text-[11px] tracking-[0.3em] sm:tracking-[0.35em] text-[#F5C77A] mb-5 sm:mb-8 font-light">{t.eyebrow}</p>
          <h1 className="text-white text-4xl sm:text-5xl lg:text-7xl leading-[1.05] mb-5 sm:mb-8 max-w-3xl"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}>
            {t.heroTitle}<br />
            <span className="italic font-light text-[#F5C77A]">{t.heroTitleAccent}</span>
          </h1>
          <p className="text-white/80 text-sm sm:text-base lg:text-lg leading-relaxed max-w-xl mb-7 sm:mb-10 font-light">{t.heroSubtitle}</p>
          <div className="flex flex-wrap gap-3 sm:gap-4">
            <a href={WA_LINK} target="_blank" rel="noopener noreferrer"
               className="group inline-flex items-center gap-2 sm:gap-3 px-7 sm:px-9 py-3.5 sm:py-4 bg-gradient-to-r from-[#FFE5A8] via-[#F5C77A] to-[#E0A954] hover:from-[#FFEDB8] hover:to-[#E8B86C] text-[#0A0807] text-[11px] sm:text-[12px] tracking-[0.22em] sm:tracking-[0.28em] font-semibold transition-all duration-500 rounded-sm shadow-[0_12px_40px_-10px_rgba(245,199,122,0.55)] hover:shadow-[0_18px_55px_-10px_rgba(245,199,122,0.75)] hover:-translate-y-0.5">
              <MessageCircle className="w-4 h-4" />
              <span>{t.ctaPrimary}</span>
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </a>
            <a href="#cities"
               className="inline-flex items-center px-6 sm:px-8 py-3.5 sm:py-4 border border-white/60 text-white text-[11px] sm:text-[12px] tracking-[0.2em] sm:tracking-[0.25em] font-medium hover:bg-white/10 hover:border-white transition rounded-sm">
              {t.ctaSecondary}
            </a>
          </div>
        </div>
      </section>

      {/* Hook — stats */}
      <section className="relative bg-[#0A0807] text-white overflow-hidden py-20 sm:py-28 lg:py-32" data-testid="hub-hook">
        <div className="absolute inset-0 opacity-[0.06] pointer-events-none"
             style={{ backgroundImage: "radial-gradient(#D4B896 0.5px, transparent 0.5px)", backgroundSize: "22px 22px" }} />
        <div className="absolute -top-32 -left-32 w-[480px] h-[480px] rounded-full bg-[#F5C77A]/10 blur-3xl pointer-events-none" />
        <div className="absolute -bottom-32 -right-32 w-[480px] h-[480px] rounded-full bg-[#7C2D3D]/15 blur-3xl pointer-events-none" />

        <div className="relative max-w-4xl mx-auto px-5 sm:px-10 text-center">
          <div className="flex items-center justify-center gap-2 sm:gap-3 mb-7 sm:mb-9">
            <span className="w-10 sm:w-16 h-px bg-[#F5C77A]" />
            <Diamond className="w-3 h-3 sm:w-4 sm:h-4 text-[#F5C77A]" />
            <span className="w-10 sm:w-16 h-px bg-[#F5C77A]" />
          </div>
          <h2 className="text-3xl sm:text-5xl lg:text-6xl leading-[1.1] mb-5 sm:mb-7"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}>
            <span className="text-white">{t.hookQuote}</span><br />
            <span className="italic text-[#F5C77A]">{t.hookQuoteAccent}</span>
          </h2>
          <p className="text-sm sm:text-base lg:text-lg text-white/65 font-light max-w-2xl mx-auto leading-relaxed mb-12 sm:mb-16">
            {t.hookSubtitle}
          </p>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-8 sm:gap-y-10 border-t border-white/10 pt-10 sm:pt-12">
            {t.hookStats.map((s, i) => (
              <div key={i} className="text-center" data-testid={`hub-hook-stat-${i}`}>
                <div className="text-4xl sm:text-5xl lg:text-6xl text-[#F5C77A] mb-2 sm:mb-3"
                     style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}>{s.value}</div>
                <div className="text-[10px] sm:text-[11px] tracking-[0.2em] sm:tracking-[0.25em] text-white/55 uppercase font-light">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partners marquee */}
      <section className="bg-[#0A0807] py-10 sm:py-14 border-y border-white/5 overflow-hidden" data-testid="hub-partners">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-10 text-center mb-7 sm:mb-9">
          <p className="text-[10px] sm:text-[11px] tracking-[0.3em] sm:tracking-[0.35em] text-[#F5C77A] mb-2 sm:mb-3 font-light">{t.partnersEyebrow}</p>
          <p className="text-xs sm:text-sm text-white/55 font-light max-w-xl mx-auto">{t.partnersTitle}</p>
        </div>
        <div className="relative">
          <div className="absolute left-0 top-0 bottom-0 w-16 sm:w-24 bg-gradient-to-r from-[#0A0807] to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-16 sm:w-24 bg-gradient-to-l from-[#0A0807] to-transparent z-10 pointer-events-none" />
          <div className="flex gap-10 sm:gap-16 animate-marquee whitespace-nowrap will-change-transform">
            {[...t.partners, ...t.partners].map((p, i) => (
              <span key={i} className="text-[11px] sm:text-[13px] tracking-[0.25em] sm:tracking-[0.3em] text-white/45 hover:text-[#F5C77A] transition font-medium uppercase select-none">{p}</span>
            ))}
          </div>
        </div>
      </section>

      {/* Cities */}
      <section id="cities" className="relative bg-[#0A0807] py-16 sm:py-24 lg:py-32 overflow-hidden" data-testid="hub-cities">
        <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
             style={{ backgroundImage: "radial-gradient(#D4B896 0.5px, transparent 0.5px)", backgroundSize: "26px 26px" }} />

        <div className="relative max-w-[1400px] mx-auto px-5 sm:px-10">
          <div className="text-center mb-10 sm:mb-14">
            <p className="text-[10px] sm:text-[11px] tracking-[0.3em] sm:tracking-[0.35em] text-[#F5C77A] mb-3 sm:mb-4 font-light">{t.citiesEyebrow}</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl text-white leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}>
              {t.citiesTitle} <span className="italic text-[#F5C77A]">{t.citiesTitleAccent}</span>
            </h2>
            <p className="text-sm sm:text-base text-white/60 font-light mt-4 sm:mt-5 max-w-2xl mx-auto leading-relaxed">{t.citiesSubtitle}</p>
            <div className="w-12 sm:w-16 h-px bg-[#F5C77A] mx-auto mt-5 sm:mt-6" />
          </div>

          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5">
            {activeCities.map(city => {
              const name = lang === "en" ? city.nameEn : city.name;
              const country = city.country[lang] || city.country.en;
              return (
                <Link key={city.slug} to={`/weddings/${city.slug}${lang !== "ru" ? `?lang=${lang}` : ""}`}
                      className="group relative overflow-hidden rounded-sm bg-[#1F1815] aspect-[3/4] sm:aspect-[4/5] flex flex-col justify-end ring-1 ring-[#F5C77A]/30 hover:ring-[#F5C77A] hover:shadow-[0_18px_45px_-15px_rgba(245,199,122,0.4)] transition-all duration-500"
                      data-testid={`hub-city-${city.slug}`}>
                  <img src={city.heroImage} alt={`${name} wedding floristry`}
                       className="absolute inset-0 w-full h-full object-cover opacity-55 group-hover:opacity-80 group-hover:scale-105 transition-all duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A0807] via-[#0A0807]/55 to-transparent" />
                  <div className="relative p-4 sm:p-7 text-white">
                    <p className="text-[9px] sm:text-[10px] tracking-[0.25em] sm:tracking-[0.3em] text-[#F5C77A] mb-1.5 sm:mb-2">{country.toUpperCase()}</p>
                    <h3 className="text-xl sm:text-3xl mb-2 sm:mb-3" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}>{name}</h3>
                    <div className="inline-flex items-center gap-1.5 sm:gap-2 text-[10px] sm:text-[11px] tracking-[0.2em] sm:tracking-[0.25em] text-[#F5C77A] group-hover:gap-3 transition-all">
                      {lang === "en" ? "EXPLORE" : "ОТКРЫТЬ"} <ArrowRight className="w-3 h-3" />
                    </div>
                  </div>
                </Link>
              );
            })}

            {/* Coming-soon city tiles */}
            {t.soonCities.map(c => (
              <div key={c.name} className="relative overflow-hidden rounded-sm bg-white/[0.04] aspect-[3/4] sm:aspect-[4/5] flex flex-col justify-end border border-white/10"
                   data-testid={`hub-city-soon-${c.name}`}>
                <div className="absolute inset-0 flex items-center justify-center opacity-[0.07]">
                  <Flower2 className="w-20 h-20 sm:w-32 sm:h-32 text-[#F5C77A]" strokeWidth={0.5} />
                </div>
                <div className="relative p-4 sm:p-7 text-white">
                  <p className="text-[9px] sm:text-[10px] tracking-[0.25em] sm:tracking-[0.3em] text-[#F5C77A]/70 mb-1.5 sm:mb-2">{c.country.toUpperCase()}</p>
                  <h3 className="text-xl sm:text-3xl mb-2 sm:mb-3 text-white/85" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}>{c.name}</h3>
                  <span className="inline-block text-[9px] sm:text-[10px] tracking-[0.25em] sm:tracking-[0.3em] px-2 sm:px-3 py-0.5 sm:py-1 bg-[#F5C77A]/15 text-[#F5C77A] rounded-sm">{t.soonLabel}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="bg-[#FAF5EE] py-16 sm:py-24 lg:py-32" data-testid="hub-values">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-10">
          <div className="text-center mb-10 sm:mb-14">
            <p className="text-[10px] sm:text-[11px] tracking-[0.3em] sm:tracking-[0.35em] text-[#B8966F] mb-3 sm:mb-4 font-light">{t.valueEyebrow}</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl text-[#1F1815] leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}>
              {t.valueTitle} <span className="italic text-[#8B6F47]">{t.valueTitleAccent}</span>
            </h2>
            <p className="text-sm sm:text-base text-[#6B5D4F] font-light mt-4 sm:mt-5 max-w-2xl mx-auto leading-relaxed">{t.valueSubtitle}</p>
            <div className="w-12 sm:w-16 h-px bg-[#C9A87C] mx-auto mt-5 sm:mt-6" />
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
            {t.values.map((v, i) => (
              <div key={i} className="text-center">
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-white border border-[#EFE4D2] flex items-center justify-center mx-auto mb-4 sm:mb-5">
                  <Sparkles className="w-4 h-4 sm:w-5 sm:h-5 text-[#8B6F47]" strokeWidth={1.5} />
                </div>
                <h3 className="text-sm sm:text-base font-medium text-[#1F1815] mb-2 sm:mb-3">{v.title}</h3>
                <p className="text-xs sm:text-sm text-[#6B5D4F] font-light leading-relaxed">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SEO Content */}
      <section className="bg-white py-16 sm:py-24 lg:py-32" data-testid="hub-seo">
        <div className="max-w-4xl mx-auto px-5 sm:px-10">
          <div className="text-center mb-12 sm:mb-16">
            <p className="text-[10px] sm:text-[11px] tracking-[0.3em] sm:tracking-[0.35em] text-[#B8966F] mb-3 sm:mb-4 font-light">{t.seoEyebrow}</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl text-[#1F1815] leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}>
              {t.seoTitle} <span className="italic text-[#8B6F47]">{t.seoTitleAccent}</span>
            </h2>
            <div className="w-12 sm:w-16 h-px bg-[#C9A87C] mx-auto mt-5 sm:mt-7" />
          </div>

          <div className="space-y-10 sm:space-y-12">
            {t.seoBlocks.map((b, i) => (
              <article key={i} data-testid={`hub-seo-block-${i}`}>
                <h3 className="text-xl sm:text-2xl lg:text-3xl text-[#1F1815] mb-3 sm:mb-4"
                    style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
                  {b.heading}
                </h3>
                <div className="w-8 h-px bg-[#C9A87C] mb-4 sm:mb-5" />
                <p className="text-sm sm:text-base text-[#3D2F22] font-light leading-[1.85]">{b.content}</p>
              </article>
            ))}
          </div>

          <div className="mt-14 sm:mt-16 pt-10 sm:pt-12 border-t border-[#EFE4D2] text-center">
            <p className="text-sm sm:text-base text-[#3D2F22] font-light leading-[1.85] max-w-2xl mx-auto mb-8 sm:mb-10">
              {t.seoFinal}
            </p>
            <a href={WA_LINK} target="_blank" rel="noopener noreferrer"
               className="inline-flex items-center gap-2 sm:gap-3 px-7 sm:px-9 py-3.5 sm:py-4 bg-[#0A0807] hover:bg-black text-[#F5C77A] text-[11px] sm:text-[12px] tracking-[0.22em] sm:tracking-[0.25em] font-medium transition-all rounded-sm hover:gap-3 sm:hover:gap-4"
               data-testid="hub-seo-cta">
              <MessageCircle className="w-4 h-4" />
              <span>{t.seoCta}</span>
              <ArrowRight className="w-3 h-3" />
            </a>
          </div>
        </div>
      </section>

      {/* Lead form */}
      <HubLeadForm
        lang={lang}
        variant="dark"
        service="wedding"
        cities={activeCities.map((c) => ({ slug: c.slug, label: lang === "en" ? c.nameEn : c.name }))}
        copy={t.lead}
      />

      {/* FAQ — wedding floristry */}
      {weddingFaq.length > 0 && (
        <div data-testid="hub-faq">
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: weddingFaq.map((f) => ({
                "@type": "Question",
                name: f.q,
                acceptedAnswer: { "@type": "Answer", text: f.a },
              })),
            }) }}
          />
          <FaqSection t={{ faqTitle, faq: weddingFaq }} />
        </div>
      )}

      {/* Bottom CTA — dramatic dark */}
      <section className="relative bg-[#0A0807] text-white overflow-hidden" data-testid="hub-bottom-cta">
        <div className="absolute inset-0">
          <img src="/weddings/bodrum/hero.webp" alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A0807] via-[#0A0807]/85 to-[#0A0807]" />
        </div>
        <div className="absolute inset-0 opacity-[0.05] pointer-events-none"
             style={{ backgroundImage: "radial-gradient(#D4B896 0.5px, transparent 0.5px)", backgroundSize: "26px 26px" }} />

        <div className="relative max-w-4xl mx-auto px-5 sm:px-10 py-20 sm:py-28 lg:py-36 text-center">
          <div className="flex items-center justify-center gap-2 sm:gap-3 mb-7 sm:mb-9">
            <span className="w-10 sm:w-16 h-px bg-[#F5C77A]" />
            <Diamond className="w-3 h-3 sm:w-4 sm:h-4 text-[#F5C77A]" />
            <span className="w-10 sm:w-16 h-px bg-[#F5C77A]" />
          </div>
          <h2 className="text-4xl sm:text-6xl lg:text-7xl leading-[1.05] mb-6 sm:mb-8"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}>
            <span className="text-white">{t.bottomTitle}</span><br/>
            <span className="italic text-[#F5C77A]">{t.bottomTitleAccent}</span>
          </h2>
          <p className="text-sm sm:text-base lg:text-lg text-white/65 font-light leading-relaxed max-w-xl mx-auto mb-10 sm:mb-12">
            {t.bottomSubtitle}
          </p>
          <a href={WA_LINK} target="_blank" rel="noopener noreferrer"
             className="group inline-flex items-center gap-3 px-10 sm:px-14 py-4 sm:py-5 bg-gradient-to-r from-[#FFE5A8] via-[#F5C77A] to-[#E0A954] hover:from-[#FFEDB8] hover:to-[#E8B86C] text-[#0A0807] text-[12px] sm:text-[13px] tracking-[0.25em] sm:tracking-[0.3em] font-semibold transition-all duration-500 rounded-sm shadow-[0_15px_50px_-10px_rgba(245,199,122,0.5)] hover:shadow-[0_20px_70px_-10px_rgba(245,199,122,0.7)] hover:-translate-y-0.5">
            <MessageCircle className="w-4 h-4 sm:w-5 sm:h-5" />
            <span>{t.contactCta}</span>
            <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 transition-transform group-hover:translate-x-1" />
          </a>
        </div>
      </section>

      {/* Footer */}
      <WeddingsFooterFull lang={lang} />
    </div>
  );
}
